/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-array-index-key */
import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import {
  getAbandonedItems,
  sendEmail,
  getCsvAbandonedReport,
} from '../app/store/actions/abandoned';
import itemsPage from '../data/itemsPage';

import Table from '../components/table/table';
import ModalComponent from '../components/modal';

class Abandoned extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      limit: itemsPage.page.limit,
      page: 1,
      field: 'createdAt',
      orderBy: 'DESC',
      combinedData: [],
      originalData: [],
      filteredData: [],
      initialDate: moment()
        .startOf('month')
        .startOf('day')
        .format('YYYY-MM-DD HH:mm:ss'),
      finalDate: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      filterDaysAgo: 1,
      showModal: false,
      userId: null,
      type: null,
      clientId: null,
      searchType: '0',
      searchSended: '0',
    };
  }

  componentDidMount() {
    this.searchAbandoned();
  }

  searchAbandoned = async () => {
    const { initialDate, finalDate, searchType } = this.state;

    if (searchType !== '0') {
      await this.setState({ searchType: '0' });
    }

    await this.props.getAbandonedItems(initialDate, finalDate);

    const { abandonedItems } = this.props;

    if (abandonedItems) {
      const {
        cartsAbandoned = {},
        userWithQuotation = [],
        userWithoutPurchase = [],
      } = abandonedItems;

      const combinedData = [
        ...Object.values(cartsAbandoned),
        ...userWithQuotation,
        ...userWithoutPurchase,
      ];

      const sortedData = combinedData.sort((a, b) => {
        const parseDate = (dateStr) => {
          if (!dateStr || dateStr === '-') return 0;
          const [datePart, timePart] = dateStr.split(' ');
          const [day, month, year] = datePart.split('/');
          const [hours, minutes] = (timePart || '00:00').split(':');
          return new Date(year, month - 1, day, hours, minutes).getTime();
        };

        return parseDate(b.date) - parseDate(a.date);
      });

      this.setState({
        combinedData: sortedData,
        originalData: [],
      });
    }
  };

  updateValues = async (search = '', pages = 1) => {
    const {
      combinedData, originalData, searchSended, searchType,
    } = this.state;

    if (combinedData.length > 0 && originalData.length === 0) {
      this.setState({ originalData: combinedData });
    }

    const dataToFilter = originalData.length > 0 ? originalData : combinedData;

    let filteredData = [...dataToFilter];

    if (searchSended === '1') {
      filteredData = filteredData.filter(item => item.emailSended === 'Si');
    } else if (searchSended === '2') {
      filteredData = filteredData.filter(item => item.emailSended === 'No');
    }

    if (searchType === '1') {
      filteredData = filteredData.filter(
        item => item.type === 'userWithoutPurchase',
      );
    } else if (searchType === '2') {
      filteredData = filteredData.filter(
        item => item.type === 'userWithQuotation',
      );
    } else if (searchType === '3') {
      filteredData = filteredData.filter(
        item => item.type === 'cartsAbandoned',
      );
    }

    if (search && search.length > 0) {
      const filterLower = search.toLowerCase();
      filteredData = filteredData.filter(
        item => (item.type && item.type.toLowerCase().includes(filterLower))
          || (item.email && item.email.toLowerCase().includes(filterLower))
          || (item.client && item.client.toLowerCase().includes(filterLower))
          || (item.cnpj && item.cnpj.toLowerCase().includes(filterLower))
          || (item.manager && item.manager.toLowerCase().includes(filterLower))
          || (item.place && item.place.toLowerCase().includes(filterLower)),
      );
    }

    this.setState({
      combinedData: filteredData,
      search,
      page: pages,
    });
  };

  getMinDate = () => {
    const currentDate = moment().toDate();
    const minDate = moment().toDate();
    minDate.setDate(currentDate.getDate() - 120);

    return minDate;
  };

  getMaxDate = () => moment().toDate();

  validateAndFilterByDate = async (initialDate, finalDate) => {
    let newInitialDate;
    let newFinalDate;

    if (!initialDate || !finalDate) {
      newInitialDate = moment()
        .startOf('month')
        .startOf('day')
        .format('YYYY-MM-DD HH:mm:ss');
      newFinalDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
    } else {
      newInitialDate = moment(initialDate)
        .startOf('day')
        .format('YYYY-MM-DD HH:mm:ss');
      newFinalDate = moment(finalDate)
        .endOf('day')
        .format('YYYY-MM-DD HH:mm:ss');
    }

    await this.setState({
      initialDate: newInitialDate,
      finalDate: newFinalDate,
    });
    await this.searchAbandoned();
  };

  handleDate = (date, type) => {
    this.setState({ [type]: date });
  };

  handleSendEmailNotificationModal = async (userId, type, clientId) => {
    await this.setState({
      userId,
      type,
      clientId,
      showModal: true,
    });
  };

  setFilterType = async (typeSearch, orderFieldValue) => {
    await this.setState({ [typeSearch]: orderFieldValue });
    this.updateValues();
  };

  sortTable = async (field, orderBy) => {
    const { combinedData } = this.state;

    const sortedData = [...combinedData].sort((a, b) => {
      let aValue = a[field];
      let bValue = b[field];

      if (field === 'createdAt' || field === 'emailSentDate') {
        const parseDate = (dateStr) => {
          if (!dateStr || dateStr === '-') return 0;
          const [datePart, timePart] = dateStr.split(' ');
          const [day, month, year] = datePart.split('/');
          const [hours, minutes] = (timePart || '00:00').split(':');
          return new Date(year, month - 1, day, hours, minutes).getTime();
        };

        aValue = parseDate(aValue);
        bValue = parseDate(bValue);
      }

      if (orderBy === 'ASC') {
        return aValue > bValue ? 1 : -1;
      }
      return aValue < bValue ? 1 : -1;
    });

    await this.setState({
      combinedData: sortedData,
      orderBy,
      field,
    });
  };

  handleSendEmailNotification = async () => {
    const { userId, type, clientId } = this.state || this.props;

    await this.props.sendEmail(userId, type, clientId);
    await this.setState({ showModal: false });

    await this.searchAbandoned();
  };

  handleSendEmail = async (userId, type, clientId, emailSended) => {
    if (emailSended === 'Si') {
      this.handleSendEmailNotificationModal(userId, type, clientId);
    } else {
      await this.props.sendEmail(userId, type, clientId);
      await this.searchAbandoned();
    }
  };

  translateType = (type) => {
    const typeMap = {
      cartsAbandoned: I18n.t('abandonedCart'),
      userWithQuotation: I18n.t('userWithQuotation'),
      userWithoutPurchase: I18n.t('userWithoutPurchase'),
    };
    return typeMap[type] || type;
  };

  render() {
    const {
      limit,
      page,
      combinedData,
      showModal,
      initialDate,
      finalDate,
      searchType,
      searchSended,
    } = this.state;

    const isFiltered = searchType !== '0' || searchSended !== '0';
    const minDate = this.getMinDate();
    const maxDate = this.getMaxDate();

    const tableHeader = [
      { key: 'client', value: I18n.t('client') },
      { key: 'cnpj', value: I18n.t('cnpj') },
      { key: 'email', value: I18n.t('email') },
      { key: 'type', value: I18n.t('typeEmail') },
      { key: 'place', value: I18n.t('place') },
      { key: 'manager', value: I18n.t('manager') },
      { key: 'emailSended', value: I18n.t('emailSended') },
      { key: 'emailSentDate', value: I18n.t('emailSentDate') },
      { key: 'createdAt', value: I18n.t('dateTime') },
      { key: 'action', value: I18n.t('action') },
    ];

    const tableButtons = (
      <React.Fragment>
        <button
          onClick={() => this.props.getCsvAbandonedReport(
            initialDate,
            finalDate,
            combinedData,
            isFiltered,
          )
          }
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>
      </React.Fragment>
    );

    const tableData = (combinedData || []).map((row, index) => ({
      key: index,
      id: row.id,
      email: row.email,
      client: row.client,
      cnpj: row.cnpj,
      place: row.place || '-',
      manager: row.manager || '-',
      purchaseId: row.purchaseId,
      createdAt: row.date,
      emailSended: row.emailSended,
      emailSentDate: row.emailSended === 'Si' ? row.emailSentDate || '-' : '-',
      type: this.translateType(row.type),
      userId: row.userId || row.id || (row.user && row.user.id),
      clientId: row.clientId,
      showTimer: (
        <span className={row.showTimer ? 'status-active' : 'status-inactive'}>
          <Translate value={row.showTimer ? 'active2' : 'inactive'} />
        </span>
      ),
      action: (
        <div
          className="btn-group"
          role="group"
          aria-label="Button group with nested dropdown"
        >
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Translate value="action" />
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => this.handleSendEmail(
                  row.userId,
                  row.type,
                  row.clientId,
                  row.emailSended,
                )
                }
              >
                <Translate value={I18n.t('sendEmail')} />
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={I18n.t('Enviar Email?')}
          body="Deseja realmente enviar o Correo Eletrónico?"
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('confirm')}
          size={{ width: '300px' }}
          showButtons
          showCancel
          confirmModal={this.handleSendEmailNotification}
        />
        <Table
          title={I18n.t('cartTracking')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData.slice((page - 1) * limit, page * limit)}
          alternativeExtras
          filterByDate={this.validateAndFilterByDate}
          page={page}
          perPage={limit}
          count={tableData.length}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
          minDate={minDate}
          maxDate={maxDate}
          extras={(
            <React.Fragment>
              <div
                style={{
                  display: 'flex',
                  marginTop: '-1.5rem',
                  gap: '1rem',
                }}
              >
                <div style={{ display: 'grid', justifyItems: 'center' }}>
                  <label htmlFor={I18n.t('typeEmail')}>
                    {I18n.t('typeEmail')}
                  </label>
                  <select
                    onChange={e => this.setFilterType('searchType', e.target.value)
                    }
                    style={{ width: 'max-Content', height: '34px' }}
                    className="float-right custom-select"
                    value={searchType}
                    disabled={false}
                    required
                  >
                    <option value="0">{I18n.t('labelSelectTypeEmail')}</option>
                    <option value="1">{I18n.t('userWithoutPurchase')}</option>
                    <option value="2">{I18n.t('userWithQuotation')}</option>
                    <option value="3">{I18n.t('abandonedCart')}</option>
                  </select>
                </div>
                <div style={{ display: 'grid', justifyItems: 'center' }}>
                  <label htmlFor={I18n.t('emailSended')}>
                    {I18n.t('emailSended')}
                  </label>
                  <select
                    onChange={e => this.setFilterType('searchSended', e.target.value)
                    }
                    style={{ width: 'max-Content', height: '34px' }}
                    className="float-right custom-select"
                    value={searchSended}
                    disabled={false}
                    required
                  >
                    <option value="0">{I18n.t('allSolicitations')}</option>
                    <option value="1">{I18n.t('Si')}</option>
                    <option value="2">{I18n.t('No')}</option>
                  </select>
                </div>
              </div>
            </React.Fragment>
          )}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getAbandonedItems: (initialDate, finalDate) => dispatch(getAbandonedItems(initialDate, finalDate)),
  sendEmail: (userId, type, clientId) => dispatch(sendEmail(userId, type, clientId)),
  getCsvAbandonedReport: (initialDate, finalDate, combinedData, isFiltered) => dispatch(
    getCsvAbandonedReport(initialDate, finalDate, combinedData, isFiltered),
  ),
});

const mapStateToProps = state => ({
  companyTag: state.settings.companyTag,
  abandonedItems: state.abandonedItems,
});

export default connect(mapStateToProps, mapDispatchToProps)(Abandoned);
